import { initialAbility } from './config'

/**
 * Build CASL ability rules from login/user payload.
 * @param {Object} user
 * @returns {Array<{action: string, subject: string}>}
 */
export function buildAbilityRules(user = {}) {
  const rules = [...initialAbility]

  if (user.full_access) {
    rules.push({ action: 'manage', subject: 'all' })
    return rules
  }

  const permissions = user.permissions || []
  permissions.forEach(permission => {
    if (permission && permission.name && permission.resource) {
      rules.push({
        action: permission.name,
        subject: permission.resource,
      })
    }
  })

  return rules
}

export const _ = undefined
